import { Box } from '@coolblue-development/freddy';
import showAccessoryProductsTrigger from '@coolblue-development/ga4-events/triggers/OptionsRow/showAccessoryProductsTrigger';
import viewTrigger from '@coolblue-development/ga4-events/triggers/OptionsRow/viewTrigger';
import { TrackImmediate, TrackWhenVisible } from '@coolblue-development/next-analytics/client';
import useDefaultContentToOptionsRowSection from '@features/add-to-cart-page/components/Sections/defaultOptionsRowSectionTextComposer';
import OptionsRow from '@features/add-to-cart-page/components/Sections/OptionsRow/OptionsRow';
import SectionTitle from '@features/add-to-cart-page/components/SectionTitle/SectionTitle';
import { ATCPageOptionsRowSection } from '@features/add-to-cart-page/typings/OptionsRowSection';
import { getAddToCartPageType } from '@features/add-to-cart-page/utils/getAddToCartPageType';
import { mapSlotsToProducts } from '@features/add-to-cart-page/utils/optionsRowSection';
import useTestId from '@hooks/useTestId';

import { AddToCartPageSectionProps } from '../../typings/AddToCartPageSection';
import { useCustomerContext } from './CustomerContext/CustomerContext';

export function ClassificationOptionsRowSection({
  product,
  section,
  order
}: AddToCartPageSectionProps) {
  const { isBusinessCustomer } = useCustomerContext();
  const addToCartPageType = getAddToCartPageType({ isBusiness: isBusinessCustomer });
  const classificationsOptionsRowSection = section as ATCPageOptionsRowSection;

  const sectionWithDefaults = useDefaultContentToOptionsRowSection(
    classificationsOptionsRowSection
  );

  const productIds = mapSlotsToProducts(sectionWithDefaults.slots);

  const trackImmediateParams = {
    sub_feature: addToCartPageType,
    primary_item_id: product.id,
    is_fallback: sectionWithDefaults.isFallback,
    attached_item_ids: productIds
  };

  const trackWhenVisibleParams = {
    item_ids: productIds,
    sub_feature: addToCartPageType
  };

  return (
    <Box mt={800} component='section' {...useTestId('options-row-section')}>
      <TrackImmediate trigger={showAccessoryProductsTrigger(trackImmediateParams)} />
      <TrackWhenVisible trigger={viewTrigger(trackWhenVisibleParams)}>
        <SectionTitle title={sectionWithDefaults.title} index={order} />
        <OptionsRow
          {...sectionWithDefaults}
          mainProductId={product.id}
          addToCartPageType={addToCartPageType}
        />
      </TrackWhenVisible>
    </Box>
  );
}
